import { Button } from '@mui/material';
import 'react-animated-slider/build/horizontal.css';
import Anchor from '../../buttons/Anchor';
import './css/slider-animations.css';
import './css/styles.css';
import Flickity from 'react-flickity-component';
import "./css/flickity.css";

const Slider = ({data}) => {
    const flickityOptions = {
        initialIndex: 0,
        wrapAround: true,
        autoPlay: 5000,
        prevNextButtons: false,
        pageDots: true
    }
    const divs = [];
    {data.map((item) => (     
        divs.push(<div
            key={item.id}
            className="slider-content"
            style={{ background: item.image_slider ? `linear-gradient(rgba(255,255,255,0) 40%, rgba(0,0,0,0.75) 100%), url('${item.image_slider.fileContent}') ` : '' +  'no-repeat center center', backgroundSize: '100% auto'}}
        >
            <div className="inner">
                <h1>{item.title}</h1>
                <p>{item.description}</p>
                
                <Button color="secondary"><Anchor color="secondary" to={`/article/view/${item.id}`}>
                    LIRE LA SUITE
                </Anchor></Button>
            </div>
        </div>)
    ))}
    
    return (
        <Flickity
            className="slider-wrapper" // default ''
            elementType={'div'} // default 'div'
            options={flickityOptions} // takes flickity options {}
            disableImagesLoaded={false} // default false
            reloadOnUpdate // default false
            static // default false
        >
            {divs}
        </Flickity>
    )
};

export default Slider;
